import { ReviewPartSchemaDetailsCourierTypeNameEnum } from 'bundles/grading/api/types';
import type { SubmissionManager } from 'bundles/grading/components/staff-graded-assignments/SubmissionManager';
import { getRubricSchemaType } from 'bundles/grading/utils/formPartUtils';
import { isManuallyGradedQuestion } from 'bundles/grading/utils/submissionUtils';

/**
 * Function to determine if we should autofocus the next button.
 */
export const shouldAutoFocusNextButton = (dataPending: boolean, submission?: SubmissionManager | null) => {
  // Do not autofocus the next button if the submission is loading or there is an error.
  if (dataPending) {
    return false;
  }

  // Autofocus the next button if user doesn't have any submission.
  if (!submission) {
    return true;
  }

  // Autofocus the next button if the question is auto-graded.
  if (submission.currentQuestion && !isManuallyGradedQuestion(submission.currentQuestion)) {
    return true;
  }

  // Autofocus the next button if there isn't any rubric - e.g. SGA has only assignment rubrics.
  if (!submission.currentRubric) {
    return true;
  }

  // Autofocus the next button if we are on the inline feedback rubric.
  const schemaType = getRubricSchemaType(submission.currentRubric);

  if (schemaType === ReviewPartSchemaDetailsCourierTypeNameEnum.BoxViewDocumentAnnotationReviewSchema) {
    return true;
  }

  return false;
};
